import React from 'react';
import { MapPin, Calendar, Target } from 'lucide-react';
import { portfolioContent } from '../data/mock';

const PortfolioSection = () => {
  return (
    <section id="portfolio" className="section section-light section-padding">
      <div className="container-custom">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="gold-line mx-auto mb-6" />
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold mb-4">
            {portfolioContent.title}
          </h2>
          <p 
            className="text-xl max-w-2xl mx-auto"
            style={{ color: 'var(--text-secondary)' }}
          >
            {portfolioContent.subtitle}
          </p>
        </div>

        {/* Portfolio Items */}
        <div className="space-y-8">
          {portfolioContent.assets.map((asset) => (
            <div key={asset.id} className="portfolio-card">
              <div className="grid lg:grid-cols-3 gap-8">
                {/* Left - Info */}
                <div className="lg:col-span-1">
                  <h3 
                    className="text-2xl md:text-3xl font-semibold mb-4"
                    style={{ fontFamily: "'Cormorant Garamond', serif" }}
                  >
                    {asset.name}
                  </h3>
                  <div className="space-y-3 mb-6">
                    <div className="flex items-center gap-3">
                      <Target size={18} style={{ color: 'var(--accent-gold)' }} />
                      <span style={{ color: 'var(--text-secondary)' }}>
                        {asset.industry}
                      </span>
                    </div>
                    <div className="flex items-center gap-3">
                      <Calendar size={18} style={{ color: 'var(--accent-gold)' }} />
                      <span style={{ color: 'var(--text-secondary)' }}>
                        Acquired {asset.yearAcquired}
                      </span>
                    </div>
                    <div className="flex items-center gap-3">
                      <MapPin size={18} style={{ color: 'var(--accent-gold)' }} />
                      <span style={{ color: 'var(--text-secondary)' }}>
                        {asset.location}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Right - Description & Focus */}
                <div className="lg:col-span-2">
                  <p 
                    className="text-base md:text-lg mb-6"
                    style={{ 
                      color: 'var(--text-secondary)',
                      lineHeight: '1.8'
                    }}
                  >
                    {asset.description}
                  </p>
                  
                  <h4 
                    className="text-lg font-semibold mb-4"
                    style={{ color: 'var(--accent-gold)' }}
                  >
                    Operational Focus
                  </h4>
                  <ul className="grid sm:grid-cols-2 gap-3">
                    {asset.focus.map((item, index) => (
                      <li 
                        key={index}
                        className="flex items-start gap-3"
                      >
                        <span 
                          className="mt-2 w-1.5 h-1.5 flex-shrink-0"
                          style={{ background: 'var(--accent-gold)' }}
                        />
                        <span style={{ color: 'var(--text-secondary)' }}>
                          {item}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Decorative divider */}
        <div className="divider-gold mt-24" />
      </div>
    </section>
  );
};

export default PortfolioSection;
